unit ConnectionModule;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Modules, XData.Web.Connection,
  App.Types, App.Config, UHelperServer, WEBLib.Dialogs, UUtils, UWeb.Enum,
  UConstantes;

type
  TDMConnection = class(TDataModule)
    ApiConnection: TXDataWebConnection;
    AuthConnection: TXDataWebConnection;
    CidadesProvedorConnection: TXDataWebConnection;
    procedure ApiConnectionError(Error: TXDataWebConnectionError);
    procedure ApiConnectionRequest(Args: TXDataWebConnectionRequest);
    procedure ApiConnectionResponse(Args: TXDataWebConnectionResponse);
    procedure AuthConnectionError(Error: TXDataWebConnectionError);
    procedure CidadesProvedorConnectionError(Error: TXDataWebConnectionError);
    procedure CidadesProvedorConnectionResponse(
      Args: TXDataWebConnectionResponse);
    procedure CidadesProvedorConnectionRequest(
      Args: TXDataWebConnectionRequest);
    procedure ProdutosConnectionRequest(Args: TXDataWebConnectionRequest);
    procedure WebDataModuleCreate(Sender: TObject);
  private
    FUnauthorizedAccessProc: TUnauthorizedAccessProc;
    FChamouTelaNaoAutorizado : Boolean;

    procedure SetErroNaoAutorizadoTela;
    procedure RedirectRegistroInexistenteToHome;
  public
    var
      FServidor : TServidor;
      FTokenInvalido : Boolean;

    procedure InitApp(SuccessProc: TSuccessProc;
      UnauthorizedAccessProc: TUnauthorizedAccessProc);
    procedure IniciarCidadesProvedorConnection;
    procedure IniciarLoginConnection;
  protected procedure LoadDFMValues; override; end;

var
  DMConnection: TDMConnection;

implementation

uses
  JS, Web,
  XData.Web.Request,
  XData.Web.Response,
  Auth.Service,
  View.ErrorPage;

{%CLASSGROUP 'Vcl.Controls.TControl'}

{$R *.dfm}

procedure TDMConnection.ApiConnectionError(Error: TXDataWebConnectionError);
begin
  TFViewErrorPage.DisplayConnectionError(Error);
end;

procedure TDMConnection.ApiConnectionRequest(Args: TXDataWebConnectionRequest);
var
  lIndice : Integer;
begin
  if AuthService.Authenticated then
  begin
    FTokenInvalido := AuthService.TokenInvalidoSistema;

    if not FTokenInvalido then
      Args.Request.Headers.SetValue('Authorization', 'Bearer ' + AuthService.GetToken);

    for lIndice := Low(cRotasHeaderResolucao) to High(cRotasHeaderResolucao) do
    begin
      if Pos(cRotasHeaderResolucao[lIndice], Args.Request.Uri.ToLower) > 0 then
      begin
        Args.Request.Headers.SetValue('resolucao', '150');
        Break;
      end;
    end;
  end;
end;

procedure TDMConnection.ApiConnectionResponse(Args: TXDataWebConnectionResponse);
var
  lMensagem,
  lMetodo,
  lUrl : string;
begin
  case Args.Response.StatusCode of
    401 :
    begin
      if not(FChamouTelaNaoAutorizado) then
        SetErroNaoAutorizadoTela;
    end;
    400: TUtils.OcultarDivLoading;
    410:
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Usuário não possui permissão' +
        ' para fazer essa operação!');
    end;
    500: TUtils.OcultarDivLoading;
    else
    begin
      lMensagem := Args.Response.ContentAsText.ToLower;
      lMetodo := Args.Request.Method.ToLower;
      lUrl := Args.Request.Uri.ToLower;

      if (lMetodo = 'get') and (Pos('registro não existe', lMensagem) > 0) and
        (Pos('getfsprodfrontend', lUrl) <= 0) then
      begin
        RedirectRegistroInexistenteToHome;
      end;
    end;
  end;
end;

procedure TDMConnection.AuthConnectionError(Error: TXDataWebConnectionError);
begin
  TFViewErrorPage.DisplayConnectionError(Error);
end;

procedure TDMConnection.CidadesProvedorConnectionError(
  Error: TXDataWebConnectionError);
begin
  TFViewErrorPage.DisplayConnectionError(Error);
end;

procedure TDMConnection.CidadesProvedorConnectionRequest(
  Args: TXDataWebConnectionRequest);
begin
  Args.Request.Headers.SetValue('security_token', 'dgve@p-H887-k0FVSD(2!-Z*EhClJ8lcSBeR,Y:RxWh/e)dQe/3Q=1szU=Tkp5uU');
end;

procedure TDMConnection.CidadesProvedorConnectionResponse(
  Args: TXDataWebConnectionResponse);
begin
  case Args.Response.StatusCode of
    401 :
    begin
      if not(FChamouTelaNaoAutorizado) then
        SetErroNaoAutorizadoTela;
    end;
    400: TUtils.OcultarDivLoading;
    410:
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Usuário não possui permissão' +
        ' para fazer essa operação!');
    end;
  end;
end;

procedure TDMConnection.IniciarCidadesProvedorConnection;
  procedure ConfigCidadesProvedor(Config: TAppConfig);
  begin
    if Config.ApiUrl <> '' then
      CidadesProvedorConnection.URL := Config.ApiUrl;

    CidadesProvedorConnection.Open;
  end;

begin
  FChamouTelaNaoAutorizado := False;
  LoadConfig(@ConfigCidadesProvedor);
end;

procedure TDMConnection.IniciarLoginConnection;
  procedure ConfigLogin(Config: TAppConfig);
  begin
    if Config.AuthUrl <> '' then
      AuthConnection.URL := Config.AuthUrl;

    AuthConnection.Open;
  end;

begin
  FChamouTelaNaoAutorizado := False;
  LoadConfig(@ConfigLogin);
end;

procedure TDMConnection.InitApp(SuccessProc: TSuccessProc;
  UnauthorizedAccessProc: TUnauthorizedAccessProc);

  procedure ConfigLoaded(Config: TAppConfig);
  begin
    if Config.AuthUrl <> '' then
      AuthConnection.URL := Config.AuthUrl;

    if Config.ApiUrl <> '' then
      ApiConnection.URL := Config.ApiUrl;

    AuthConnection.Open(SuccessProc);
  end;

begin
  FChamouTelaNaoAutorizado := False;
  FUnauthorizedAccessProc := UnauthorizedAccessProc;
  LoadConfig(@ConfigLoaded);
end;

procedure TDMConnection.ProdutosConnectionRequest(
  Args: TXDataWebConnectionRequest);
begin
  Args.Request.Headers.SetValue('security_token', 'YHyGZ18wmRsEW3sCVPpLAEOQsVpuoJ9yWoBYo9keh6iaUcyTWRZoFrMCV0Do0Prc');
end;

procedure TDMConnection.RedirectRegistroInexistenteToHome;
begin
  TUtils.OcultarDivLoading;
  asm
    window.__facilRouterInternalHash = false;
  end;
  window.location.hash := '#/home';
end;

procedure TDMConnection.SetErroNaoAutorizadoTela;
var
  lMensagem : string;
begin
  FChamouTelaNaoAutorizado := True;

  if FTokenInvalido then
  begin
    lMensagem := 'O token informado na requisição é inválido!';
    AuthService. Logout;
  end
  else
    lMensagem := 'O tempo de conexão expirou!' + sLineBreak + 'Efetue login novamente para continuar utilizando o sistema.';

  TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, lMensagem);
end;

procedure TDMConnection.WebDataModuleCreate(Sender: TObject);
begin
  FServidor := TServidor.SERVICE;
end;

procedure TDMConnection.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ApiConnection := TXDataWebConnection.Create(Self);
  AuthConnection := TXDataWebConnection.Create(Self);
  CidadesProvedorConnection := TXDataWebConnection.Create(Self);

  ApiConnection.BeforeLoadDFMValues;
  AuthConnection.BeforeLoadDFMValues;
  CidadesProvedorConnection.BeforeLoadDFMValues;
  try
    Name := 'DMConnection';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    Height := 264;
    Width := 395;
    ApiConnection.SetParentComponent(Self);
    ApiConnection.Name := 'ApiConnection';
    ApiConnection.URL := 'https://server.apisfacil.com/facilsistemas/apis/';
    SetEvent(ApiConnection, Self, 'OnError', 'ApiConnectionError');
    SetEvent(ApiConnection, Self, 'OnRequest', 'ApiConnectionRequest');
    SetEvent(ApiConnection, Self, 'OnResponse', 'ApiConnectionResponse');
    ApiConnection.Left := 48;
    ApiConnection.Top := 80;
    AuthConnection.SetParentComponent(Self);
    AuthConnection.Name := 'AuthConnection';
    AuthConnection.URL := 'https://server.apisfacil.com/facilsistemas/apis/auth';
    SetEvent(AuthConnection, Self, 'OnError', 'AuthConnectionError');
    AuthConnection.Left := 48;
    AuthConnection.Top := 16;
    CidadesProvedorConnection.SetParentComponent(Self);
    CidadesProvedorConnection.Name := 'CidadesProvedorConnection';
    CidadesProvedorConnection.URL := 'https://server.apisfacil.com/facilsistemas/apis/';
    SetEvent(CidadesProvedorConnection, Self, 'OnError', 'CidadesProvedorConnectionError');
    SetEvent(CidadesProvedorConnection, Self, 'OnRequest', 'CidadesProvedorConnectionRequest');
    SetEvent(CidadesProvedorConnection, Self, 'OnResponse', 'CidadesProvedorConnectionResponse');
    CidadesProvedorConnection.Left := 200;
    CidadesProvedorConnection.Top := 24;
  finally
    ApiConnection.AfterLoadDFMValues;
    AuthConnection.AfterLoadDFMValues;
    CidadesProvedorConnection.AfterLoadDFMValues;
  end;
end;

end.
